import { FC, ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useTranslation } from 'react-i18next'

const ReCaptchaProvider: FC<{ children: ReactNode }> = props => {
    const { i18n } = useTranslation()
    return <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
        language={i18n.language}>
        {props.children}
    </GoogleReCaptchaProvider >
}

export default ReCaptchaProvider